import { useEffect } from 'react';
import styled from '@emotion/styled';
import { QueryClientProvider } from '@tanstack/react-query';
import '../styles.scss';
import { queryClient } from './query-client';
import RootRouter from './router/root';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as zoid from 'zoid/dist/zoid.frameworks';
import '@xplortech/apollo-core/build/style.css';
import { ConfigCatProvider } from 'configcat-react';
import { appConfig } from '../config';

export function App() {
  useEffect(() => {
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.CreateLocationsComponent = zoid.create({
        /**
         * we may not always want zoid components to take up the entire available space
         * so mileage may vary on this technique
         */
        dimensions: {
          width: '80%',
          height: '50%',
        },
        // tag means loading the correct component in the child window or frame
        // the full url that will be loaded when your component is rendered
        url: () => `${window.location.origin}/`,
        tag: 'create-locations-component',
      });
    } catch (e) {
      /* empty */
    }
  }, []);
  return (
    <ConfigCatProvider sdkKey={appConfig.configCatKey}>
      <StyledApp>
        <QueryClientProvider client={queryClient}>
          <RootRouter />
          <ToastContainer />
        </QueryClientProvider>
      </StyledApp>
    </ConfigCatProvider>
  );
}

const StyledApp = styled.div`
  // Add your custom global style here
`;

export default App;
